import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toMoney } from '../utils/numbers';
import { formatDate, formatDateTime } from '../utils/dates';

const fecha = formatDate;
const money = toMoney;
const num = (v) => ({ content: v, styles: { halign: 'right' } });
const round = (x) => Math.round((Number(x) || 0) * 100) / 100;

export function exportResultadosPdf(d, meta, { imprimir = false } = {}) {
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const W = pdf.internal.pageSize.getWidth(), H = pdf.internal.pageSize.getHeight(), M = 36;
  const t = d.totales;
  pdf.setFillColor(47, 111, 115); pdf.rect(0, 0, W, 7, 'F');
  pdf.setFont('helvetica', 'bold'); pdf.setTextColor(31, 45, 51);
  pdf.setFontSize(19); pdf.text('QUE TACO', M, 47);
  pdf.setFontSize(15); pdf.text('Estado de Resultados', M, 70);
  pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor(91, 107, 115);
  pdf.text(`Período: ${fecha(d.desde)} al ${fecha(d.hasta)}`, M, 89);
  pdf.text(`Sucursal: ${meta.sucursal}`, M, 103);
  pdf.text(`Generado: ${formatDateTime(new Date())}${meta.generadoPor ? ` por ${meta.generadoPor}` : ''}`, M, 117);
  const table = (head, body, startY, foot) => {
    autoTable(pdf, { startY, margin: { left: M, right: M, bottom: 45 }, theme: 'grid',
      styles: { fontSize: 9, cellPadding: 5, textColor: [31, 41, 51], lineColor: [218, 229, 230] },
      headStyles: { fillColor: [31, 45, 51], textColor: 255 },
      footStyles: { fillColor: [231, 240, 240], textColor: [31, 45, 51], fontStyle: 'bold' },
      head: [head], body, ...(foot ? { foot: [foot] } : {}) });
    return pdf.lastAutoTable.finalY + 18;
  };
  const ingresos = [
    ['Ventas en efectivo',t.ventasEfectivo],['Ventas con tarjeta',t.ventasTarjeta],['PedidosYa',t.ventasPedidosYa],['Otros ingresos',t.otrosIngresos]
  ];
  const egresos = [
    ['Compras y facturas',t.compras],['Gastos',t.gastos],['Pagos operativos',t.pagosOperativos],
    ['Comisiones de tarjeta',t.comisionTarjeta],['Comisiones de PedidosYa',t.comisionPedidosYa],['Otros egresos',t.otrosEgresos]
  ];
  const rows = [
    ...ingresos.map(([label,value]) => [label,num(money(value))]), ['TOTAL INGRESOS',num(money(t.totalIngresos))],
    ...egresos.map(([label,value]) => [label,num(money(value))]), ['TOTAL EGRESOS',num(money(t.totalEgresos))],
    [t.resultado < 0 ? 'PÉRDIDA NETA' : 'GANANCIA NETA',num(money(Math.abs(t.resultado)))],
    ['Margen',num(t.margen == null ? '—' : `${t.margen.toFixed(2)} %`)]];
  let y = table(['Concepto',num('Monto')],rows,136);
  if (y > H - 90) { pdf.addPage(); y = M; }
  pdf.setFont('helvetica','bold');pdf.setFontSize(13);pdf.text('Detalle por día',M,y); y += 9;
  const detail = d.dias.map((r) => [fecha(r.fecha),r.sucursal,num(money(r.totalIngresos)),num(money(r.compras)),
    num(money(round(r.gastos+r.pagosOperativos+r.otrosEgresos))),num(money(round(r.comisionTarjeta+r.comisionPedidosYa))),num(money(r.resultado))]);
  y = table(['Día','Sucursal',num('Ingresos'),num('Compras'),num('Gastos'),num('Comisiones'),num('Resultado')],detail.length ? detail
    : [[{content:'Sin movimientos en el período',colSpan:7}]],y,
    ['TOTALES','',num(money(t.totalIngresos)),num(money(t.compras)),num(money(round(t.gastos+t.pagosOperativos+t.otrosEgresos))),
      num(money(round(t.comisionTarjeta+t.comisionPedidosYa))),num(money(t.resultado))]);
  if (d.ventasEstimadas) {
    if (y > H - 75) { pdf.addPage(); y = M; }
    pdf.setFont('helvetica','normal');pdf.setFontSize(9);pdf.setTextColor(91,107,115);
    pdf.text(`${d.ventasEstimadas} cierre(s) sin ventas del sistema: ventas en efectivo estimadas desde el conteo y las salidas.`,M,y);
  }
  const pages = pdf.getNumberOfPages();
  for (let i=1;i<=pages;i++) {
    pdf.setPage(i);pdf.setFont('helvetica','normal');pdf.setFontSize(8);pdf.setTextColor(91,107,115);
    pdf.text(`Que Taco · Estado de Resultados · ${meta.sucursal}`,M,H-22);
    pdf.text(`Página ${i} de ${pages}`,W-M,H-22,{align:'right'});
  }
  if (imprimir) {
    pdf.autoPrint();
    if (!window.open(pdf.output('bloburl'),'_blank')) pdf.save(`Resultados_${d.desde}_${d.hasta}.pdf`);
    return;
  }
  pdf.save(`Resultados_${d.desde}_${d.hasta}.pdf`);
}
